module.exports = __webpack_public_path__ + "img/26.27f38eed.png";